// components/SalaryCard/SalaryCard.jsx
import React, {useEffect, useState} from 'react';
import {Alert, Card, Statistic, Tooltip} from 'antd';
import {InfoCircleOutlined, UsergroupAddOutlined} from '@ant-design/icons';

import style from './styles/SalaryCard.module.css';
import {instance} from "../../../../../API/API";
import ExpensesType from "./ExpensesType";
import MiddleStatistic from "./MiddleStatistic";
import MinMaxSalary from "./MinMaxSalary";


const SalaryCard = ({dateRange, selectedCategory, refreshKey}) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState({
        total: 0,
        cash: 0,
        non_cash: 0,
        avg_monthly: 0,
        period: {},
        employees: {},
        highlights: {}
    });

    const fetchData = async () => {
        setLoading(true);
        setError(null);

        try {
            const params = {
                date_from: dateRange[0].format('YYYY-MM-DD'),
                date_to: dateRange[1].format('YYYY-MM-DD'),
            };

            if (selectedCategory) {
                params.category_id = selectedCategory;
            }

            const response = await instance.get(`finance_04122025/get_salary_expenses.php`, {
                params,
                withCredentials: true,
            });

            if (response.data.success) {
                setData(response.data.data);
            } else {
                throw new Error(response.data.error || 'Failed to load salary data');
            }
        } catch (err) {
            console.error('Error fetching salary data:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [dateRange, selectedCategory, refreshKey]);

    const formatCurrency = (value) => {
        return new Intl.NumberFormat('ru-RU', {
            style: 'currency',
            currency: 'EUR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };

    if (error) {
        return (
            <Card className={style.card}>
                <Alert
                    message="Ошибка"
                    description="Не удалось загрузить данные по зарплате"
                    type="error"
                    showIcon
                />
            </Card>
        );
    }

    return (
        <Card
            className={`${style.card} ${style.salaryCard}`}
            hoverable
            loading={loading}
        >
            <div className={style.cardHeader}>
                <div className={style.title}>
                    <UsergroupAddOutlined className={style.icon}/>
                    <span>Зарплата</span>
                </div>
                <Tooltip title="Расходы на зарплату сотрудников">
                    <InfoCircleOutlined className={style.infoIcon}/>
                </Tooltip>
            </div>

            <Statistic
                value={data.total}
                precision={2}
                suffix="€"
                valueStyle={{
                    color: '#52c41a',
                    fontSize: '24px',
                    fontWeight: 600
                }}
                className={style.statistic}
            />
            <ExpensesType cash={formatCurrency(data.cash)} non_cash={formatCurrency(data.non_cash)}/>
            <MiddleStatistic summ={formatCurrency(data.avg_monthly)} period={data.period_months}/>
            <MinMaxSalary
                max_salary_month={{
                    status: data.highlights.max_salary_month || false,
                    month: data.highlights.max_salary_month ? data.highlights.max_salary_month.month : null,
                    amount: data.highlights.max_salary_month ? formatCurrency(data.highlights.max_salary_month.amount) : null,
                }}
                min_salary_month={{
                    status: data.highlights.min_salary_month || false,
                    month: data.highlights.min_salary_month ? data.highlights.min_salary_month.month : null,
                    amount: data.highlights.min_salary_month ? formatCurrency(data.highlights.min_salary_month.amount) : null
                }}
            />
        </Card>
    );
};

export default SalaryCard;